import { useEffect } from 'react'
import { Building2 } from 'lucide-react'

export default function ComingSoon() {
  useEffect(() => {
    // Prevent scrolling on maintenance page
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-blue-50 to-pink-50 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full text-center space-y-8">
        {/* Animated Icon/Logo */}
        <div className="flex justify-center mb-8">
          <div className="relative">
            {/* Animated pulsing circles */}
            <div className="absolute inset-0 rounded-full bg-gradient-to-r from-purple-400 to-pink-400 opacity-75 animate-ping"></div>
            <div className="absolute inset-0 rounded-full bg-gradient-to-r from-purple-400 to-pink-400 opacity-50 animate-pulse"></div>
            <div className="relative bg-gradient-to-r from-purple-600 to-pink-500 rounded-full p-8 shadow-2xl animate-pulse">
              <Building2 className="w-16 h-16 text-white" />
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="space-y-4">
          <h1 className="text-5xl md:text-6xl font-bold bg-gradient-to-r from-purple-600 to-pink-500 bg-clip-text text-transparent animate-pulse">
            We'll Be Back Soon!
          </h1>
          <p className="text-xl md:text-2xl text-slate-600 font-medium">
            We're currently upgrading our system
          </p>
          <p className="text-lg text-slate-500 max-w-md mx-auto">
            We're working hard to bring you an improved experience. Please check back shortly.
          </p>
        </div>

        {/* Animated Progress Bar */}
        <div className="space-y-2 pt-8">
          <div className="w-full bg-slate-200 rounded-full h-2 overflow-hidden">
            <div className="h-full bg-gradient-to-r from-purple-500 via-pink-500 to-purple-500 rounded-full animate-[loading_2s_ease-in-out_infinite]"></div>
          </div>
          <p className="text-sm text-slate-500">Maintenance in progress...</p>
        </div>

        {/* Decorative Elements */}
        <div className="flex justify-center gap-4 pt-8">
          <div className="w-3 h-3 bg-purple-400 rounded-full animate-bounce" style={{ animationDelay: '0s' }}></div>
          <div className="w-3 h-3 bg-pink-400 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
          <div className="w-3 h-3 bg-blue-400 rounded-full animate-bounce" style={{ animationDelay: '0.4s' }}></div>
        </div>
      </div>

      <style>{`
        @keyframes loading {
          0% {
            transform: translateX(-100%);
          }
          50% {
            transform: translateX(0%);
          }
          100% {
            transform: translateX(100%);
          }
        }
      `}</style>
    </div>
  )
}

